import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { getCountriesUser, useCountryReducer } from '@/main/store/country';
import {
  getStatusRegister,
  useStatusRegisterReducer
} from '@/main/store/statusRegister';
import KogAutoCompleteControlled from '@/main/components/shared/inputAutoComplete/autoCompleteControlled';
import KogInputTextControlledNew from '@/main/components/shared/inputText/inputTextControlledNew';

import { KeyValue } from '@/main/models/common';
import { StatusRegisterEnum } from '@/main/services/enum/StatusRegisterEnum';
import { useInsurerRegisterContext } from '../context';
import * as S from './styles';
import { getDefaultOptionDrop, getTranslateByKey } from '@/main/services/utils';

function SectionInfo() {
  const dispatch = useDispatch();
  const countryReducer = useCountryReducer();
  const statusRegisterReducer = useStatusRegisterReducer();
  const optionDefaultCountryDrop = getDefaultOptionDrop(countryReducer.countriesUser.data);
  const {
    control,
    setValue,
    formState: { errors }
  } = useFormContext();
  const { hasScreenBranch, isAddBranch, isEdit } = useInsurerRegisterContext();

  const isDisabledCountry = () => isEdit || optionDefaultCountryDrop !== null;

  function getErrorsFieldRfc() {
    const errorTypeRfc = errors.rfc?.type;
    if (errorTypeRfc) {
      if (errorTypeRfc === 'minLength') {
        return getTranslateByKey(
          'information.rfcMustHaveAtLeast12Digits',
          true
        );
      }
      if (errorTypeRfc === 'required') {
        return getTranslateByKey('information.rfcRequired', true);
      }
    }

    return '';
  }

  useEffect(() => {
    dispatch(getCountriesUser());
    dispatch(getStatusRegister());
  }, []);

  return (
    <S.Container>
      <KogAutoCompleteControlled
        nameCustom="country"
        label={getTranslateByKey('information.country')}
        control={control}
        disabled={(hasScreenBranch && isAddBranch) || isDisabledCountry()}
        rulesCustom={{ required: true }}
        errorMessageCustom={
          errors.country?.type === 'required'
            ? getTranslateByKey('information.countryRequired', true)
            : ''
        }
        hasErrorCustom={!!errors.country}
        options={countryReducer.countriesUser.data}
        isLoading={countryReducer.countriesUser.isLoading}
        onChangeCustom={(optionSelected: KeyValue | null) => {}}
        id="id-registerInsurer-txt-country"
        autoHighlightCustom={!!optionDefaultCountryDrop}
        setValueCustom={setValue}
      />
      <KogInputTextControlledNew
        name="companyName"
        label={getTranslateByKey('information.companyName')}
        control={control}
        controllerProps={{ rules: { required: true } }}
        errorMessageCustom={
          errors.companyName?.type === 'required'
            ? getTranslateByKey('information.companyNameRequired', true)
            : ''
        }
        id="id-registerInsurer-txt-companyName"
      />
      <KogInputTextControlledNew
        name="rfc"
        label={getTranslateByKey('information.rfc')}
        control={control}
        inputProps={{ maxLength: 20 }}
        controllerProps={{ rules: { required: true, minLength: 12 } }}
        helperText={getErrorsFieldRfc()}
        error={!!errors.rfc}
        id="id-registerInsurer-txt-rfc"
      />
      <KogAutoCompleteControlled
        label={getTranslateByKey('information.status')}
        nameCustom="status"
        valueDefaultKey={
          !isEdit ? String(StatusRegisterEnum.Active) : undefined
        }
        setValueCustom={setValue}
        options={statusRegisterReducer.statusRegister.data}
        isLoading={statusRegisterReducer.statusRegister.isLoading}
        control={control}
        rulesCustom={{ required: true }}
        errorMessageCustom={
          errors.status?.type === 'required'
            ? getTranslateByKey('information.statusRequired', true)
            : ''
        }
        hasErrorCustom={!!errors.status}
        onChangeCustom={() => {}}
        id="id-registerInsurer-txt-status"
      />
      <KogInputTextControlledNew
        name="tradeName"
        label={getTranslateByKey('information.tradeName')}
        control={control}
        controllerProps={{ rules: { required: true } }}
        errorMessageCustom={
          errors.tradeName?.type === 'required'
            ? getTranslateByKey('information.tradeNameRequired', true)
            : ''
        }
        id="id-registerInsurer-txt-tradeName"
      />
    </S.Container>
  );
}

export default SectionInfo;
